import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const foehousekeepingApi = api
  .enhanceEndpoints({ addTagTypes: ['FOEHouseKeeping'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOEHouseKeepings: builder.query<fo_ehousekeeping[], string>({
        query: cid => `foehousekeeping/${cid}`,
        providesTags: ['FOEHouseKeeping'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (data.type === 'FRONT_OFFICE_UPDATED') {
                dispatch(
                  foehousekeepingApi.util.invalidateTags(['FOEHouseKeeping'])
                );
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getFOEHouseKeepingById: builder.query<fo_ehousekeeping, string>({
        query: id => `foehousekeeping/byid/${id}`,
        providesTags: ['FOEHouseKeeping']
      }),
      insertFOEHouseKeeping: builder.mutation({
        query: foehousekeeping => ({
          url: `foehousekeeping/`,
          method: 'POST',
          body: foehousekeeping
        }),
        invalidatesTags: ['FOEHouseKeeping']
      }),
      updateFOEHouseKeeping: builder.mutation({
        query: foehousekeeping => ({
          url: `foehousekeeping/`,
          method: 'PUT',
          body: foehousekeeping
        }),
        invalidatesTags: ['FOEHouseKeeping']
      }),
      deleteFOEHouseKeeping: builder.mutation({
        query: foehousekeeping => ({
          url: `foehousekeeping/${foehousekeeping.hk_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOEHouseKeeping']
      })
    }),
    overrideExisting: true
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOEHouseKeepingsQuery,
  useGetFOEHouseKeepingByIdQuery,
  useInsertFOEHouseKeepingMutation,
  useUpdateFOEHouseKeepingMutation,
  useDeleteFOEHouseKeepingMutation
} = foehousekeepingApi;

